import SignupValidationAPI from '../../APIs/SignupAPI/SignupValidationAPI'

export const validationThree = {
    state: {
        getValidationThreeModifier: '',
        getValidationThree: ''
    },
    actions: {
        validationThree({ commit }, signupCredentials) {
            SignupValidationAPI.validationThree(signupCredentials).then((res) => {
                // Added modifier for dialog box yes if account exist or does not exist
                commit('VALIDATION_THREE', {
                    MESSAGE: res.data.MESSAGE,
                    MODIFIER: res.data.MODIFIER
                })
            }).catch((error) => {
                // Added modifier for dialog box yes if account exist or does not exist
                commit('VALIDATION_THREE', {
                    MESSAGE: error.response.data.MESSAGE,
                    MODIFIER: error.response.data.MODIFIER
                })
            })
        }
    },
    mutations: {
        VALIDATION_THREE(state, getValidationThree) {
            state.getValidationThree = getValidationThree.MESSAGE
            state.getValidationThreeModifier = getValidationThree.MODIFIER
        },
        RESET_VALIDATION_THREE(state, param) {
            state.getValidationThreeModifier = param
            state.getValidationThree = param
        }
    },
    getters: {
        getValidationThree(state) {
            return state.getValidationThree
        },

        getYesDialogModifier(state) {
            return state.getValidationThreeModifier
        }
    }
}
